import { render } from "./AiButton.vue?vue&type=template&id=361a6a38&scoped=true"
import script from "./AiButton.vue?vue&type=script&lang=js"
export * from "./AiButton.vue?vue&type=script&lang=js"

import "./AiButton.vue?vue&type=style&index=0&id=361a6a38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361a6a38"]])

export default __exports__